import { useState, useEffect } from 'react';
import { format, parseISO } from 'date-fns'
// @mui
import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Stack,
  Typography,
  IconButton,
} from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers-pro';
// hooks
import useAuth from '../../hooks/useAuth';
// components
import { CompanyAvatar } from '../company';
import Iconify from '../../components/Iconify';


export default function TodoEditDialog({ isOpen, todo, closeDialog, edit, openDelete, isSubmitting}) {
  const { user } = useAuth();
  const [todoContent, setTodoContent] = useState('');
  const [todoContentError, setTodoContentError] = useState(false);
  const [targetDate, setTargetDate] = useState(null);
  const [targetDateError, setTargetDateError] = useState(false);


  const handleTodoContent = (e) => {
    setTodoContentError(!e.target.value);
    setTodoContent(e.target.value);
  }

  const handleTargetDate = (newValue) => {
    setTargetDateError(!newValue);
    setTargetDate(newValue);
  }

  const close = async () => {
    setTodoContent('');
    setTargetDate(null);
    setTodoContentError(false);
    setTargetDateError(false);
    closeDialog();
  }

  const editTodo = async () => {
    if (!todoContent) {
      setTodoContentError(true);
      return;
    }
    if (!targetDate) {
      setTargetDateError(true);
    }
    try {
      const formattedTargetDate = format(targetDate, 'yyyy-MM-dd');
      await edit(todoContent, formattedTargetDate);
      close();
    } catch (error) {
      setTargetDateError(true);
    }
  }

  useEffect(() => {
    if (isOpen) {
      setTodoContent(todo?.content);
      setTargetDate(parseISO(todo?.target_date));
    } else {
      setTodoContent('');
      setTargetDate(null);
      setTodoContentError(false);
      setTargetDateError(false);
    }
  }, [isOpen]);

  function DialogTitleWithCloseButton(props) {
    const { children, onClose } = props;

    return (
      <DialogTitle sx={{ mb: 3 }}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Iconify icon={'eva:close-fill'} />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="xs">
      <DialogTitleWithCloseButton onClose={close}>
        투두를 수정할까요?
      </DialogTitleWithCloseButton>
      <DialogContent sx={{ pb: 0 }}>
        <Stack spacing={1} sx={{ width: 1 }}>
          <Typography variant="subtitle2">
            업무를 한 줄로 적어주세요
          </Typography>
          <TextField
            fullWidth
            multiline
            value={todoContent}
            error={todoContentError}
            helperText={todoContentError ? '내용을 입력해주세요' : ''}
            onChange={handleTodoContent}
          />
        </Stack>

        <Stack spacing={1} sx={{ width: 1, mt: 3 }}>
          <Typography variant="subtitle2">
            완료해야 할 날짜를 설정해주세요
          </Typography>
          <DatePicker
            inputFormat="yyyy-MM-dd"
            disablePast
            mask={"____-__-__"}
            value={targetDate}
            onChange={handleTargetDate}
            renderInput={(params) => (
              <TextField {...params} error={targetDateError} helperText={targetDateError ? '날짜를 선택해주세요' : ''} fullWidth />
            )}
          />
        </Stack>

        <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2, mb: {xs: 0, sm: 3} }}>
          <CompanyAvatar nameVariant={"body2"} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          size="large"
          color="error"
          sx={{ px: 5 }}
          loading={isSubmitting}
          onClick={openDelete}
        >
          삭제
        </LoadingButton>
        <LoadingButton
          size="large"
          sx={{ px: 5 }}
          loading={isSubmitting}
          variant="contained"
          onClick={editTodo}
        >
          수정하기
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}